/**
 * @generated SignedSource<<ca9c6c46f782b7f54cd4d0c405c0c310>>
 * @relayHash 8dddd1ce7676474299e324ca788770e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type fetchProjectsQuery$variables = {
  projectIds: ReadonlyArray<string>;
};
export type fetchProjectsQuery$data = {
  readonly jira: {
    readonly jiraProjects: ReadonlyArray<{
      readonly avatar: {
        readonly large: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly key: string;
      readonly name: string;
      readonly projectId: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type fetchProjectsQuery = {
  response: fetchProjectsQuery$data;
  variables: fetchProjectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "ids",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jiraProjects",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "projectId"
          },
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "large"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "fetchProjectsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchProjectsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e",
    "metadata": {},
    "name": "fetchProjectsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bfbd83d6cfdfb7072506c62a347912b6";

export default node;
